import type { IngestStatus } from "@contract-manager/shared";
import { useI18n } from "../i18n/I18n";
import { presentIngestStatus, type StatusTone } from "../status";

const TAG_STATE: Record<StatusTone, string> = {
  pending: "--muted",
  // Only the working tone animates: it is the one state that is going to
  // change on its own, and a pulse says "still running" without more text.
  working: "--info --pulse",
  done: "--success",
  failed: "--alert",
};

export function StatusBadge({ status }: { status: IngestStatus }) {
  const { t } = useI18n();
  const { labelKey, tone } = presentIngestStatus(status);
  return (
    <span className={`ds-tag --small ${TAG_STATE[tone]}`}>
      <span>{t(labelKey)}</span>
    </span>
  );
}
